module.exports = __webpack_public_path__ + "static/img/0.4783ee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market101/0.png
// module id = pbzh
// module chunks = 1